import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FeedbackPopupComponent, NotificationsComponent } from '@forgerock/backstage-ui-components';
import { AuthModule } from '@forgerock/backstage-ui-core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
  imports: [ NotificationsComponent, FeedbackPopupComponent, RouterOutlet, AuthModule ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppComponent {}
